import React from 'react';

export const SharePointSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<g>
				<path
					d="M16.2482 17.5237C19.5362 17.5237 22.2017 14.7948 22.2017 11.4285C22.2017 8.06218 19.5362 5.33325 16.2482 5.33325C12.9601 5.33325 10.2947 8.06218 10.2947 11.4285C10.2947 14.7948 12.9601 17.5237 16.2482 17.5237Z"
					fill="#036C70"
				/>
				<path
					d="M21.2091 22.6031C24.2231 22.6031 26.6664 20.1016 26.6664 17.0158C26.6664 13.93 24.2231 11.4285 21.2091 11.4285C18.1951 11.4285 15.7517 13.93 15.7517 17.0158C15.7517 20.1016 18.1951 22.6031 21.2091 22.6031Z"
					fill="#1A9BA1"
				/>
				<path
					d="M16.9922 26.6667C19.3212 26.6667 21.2093 24.7337 21.2093 22.3492C21.2093 19.9647 19.3212 18.0317 16.9922 18.0317C14.6632 18.0317 12.7751 19.9647 12.7751 22.3492C12.7751 24.7337 14.6632 26.6667 16.9922 26.6667Z"
					fill="#37C6D0"
				/>
				<path
					opacity="0.1"
					d="M17.2403 10.8343V21.6737C17.2379 22.0503 17.0149 22.3887 16.6747 22.5321C16.5664 22.579 16.45 22.6032 16.3324 22.6032H12.7802C12.7752 22.5168 12.7752 22.4356 12.7752 22.3492C12.7736 22.2644 12.7769 22.1796 12.7851 22.0953C12.8759 20.4716 13.8529 19.0391 15.3104 18.3924V17.4476C12.0667 16.9214 9.85383 13.8026 10.3679 10.4817C10.3714 10.4587 10.3751 10.4357 10.3789 10.4127C10.4036 10.2414 10.4384 10.0718 10.4831 9.90479H16.3324C16.833 9.90674 17.2384 10.3218 17.2403 10.8343Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M15.8362 10.4126H10.3788C9.82749 13.7276 12.0054 16.8724 15.2432 17.4368C15.3413 17.4539 15.4397 17.4685 15.5385 17.4805C14.0005 18.2272 12.8797 20.3478 12.7845 22.0951C12.7762 22.1795 12.7729 22.2643 12.7746 22.3491C12.7746 22.4355 12.7746 22.5167 12.7795 22.6031C12.7885 22.7738 12.81 22.9436 12.844 23.111H15.8356C16.2035 23.1085 16.534 22.8802 16.6741 22.532C16.7199 22.4211 16.7435 22.3019 16.7435 22.1815V11.3421C16.7417 10.8298 16.3366 10.4148 15.8362 10.4126Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M15.8364 10.4126H10.379C9.8278 13.7279 12.006 16.8729 15.2442 17.4372C15.3104 17.4487 15.3768 17.4591 15.4434 17.4684C13.9551 18.2689 12.8785 20.3844 12.7852 22.0951H15.8364C16.3362 22.0913 16.7405 21.6774 16.7443 21.1656V11.3421C16.7424 10.8296 16.337 10.4145 15.8364 10.4126Z"
					fill="black"
				/>
				<path
					opacity="0.2"
					d="M15.3401 10.4126H10.3788C9.85836 13.5422 11.7738 16.5561 14.7794 17.3368C13.6414 18.668 12.9433 20.3335 12.785 22.0951H15.3401C15.8407 22.0932 16.2461 21.6782 16.248 21.1656V11.3421C16.2477 10.8289 15.8414 10.4129 15.3401 10.4126Z"
					fill="black"
				/>
				<path
					d="M6.24265 10.4126H15.3386C15.8408 10.4126 16.248 10.8294 16.248 11.3436V20.6561C16.248 21.1704 15.8408 21.5872 15.3386 21.5872H6.24265C5.7404 21.5872 5.33325 21.1704 5.33325 20.6561V11.3436C5.33325 10.8294 5.7404 10.4126 6.24265 10.4126Z"
					fill="#026D71"
				/>
				<path
					d="M9.39487 15.886C9.18175 15.7413 9.00374 15.5487 8.87443 15.3227C8.74914 15.0866 8.68669 14.8209 8.69334 14.5522C8.68218 14.1884 8.80208 13.8332 9.03021 13.5541C9.26993 13.2747 9.57979 13.0677 9.92621 12.9558C10.321 12.8227 10.7345 12.7572 11.1501 12.7617C11.6967 12.7413 12.2425 12.8195 12.7625 12.9928V14.1611C12.5366 14.021 12.2905 13.9181 12.0332 13.8563C11.7541 13.7863 11.4678 13.7511 11.1804 13.7517C10.8774 13.7403 10.5763 13.8056 10.3037 13.9417C10.0933 14.0346 9.95691 14.2465 9.95647 14.4811C9.95561 14.6234 10.009 14.7604 10.1053 14.8631C10.219 14.9841 10.3536 15.0826 10.5022 15.1536C10.6676 15.2379 10.9156 15.35 11.2464 15.4899C11.2828 15.5017 11.3183 15.5163 11.3526 15.5336C11.6781 15.6638 11.9921 15.8224 12.2912 16.0075C12.5177 16.1504 12.7078 16.3465 12.8459 16.5794C12.9874 16.8434 13.056 17.1419 13.0443 17.4429C13.0605 17.8163 12.9489 18.1839 12.7288 18.4821C12.5094 18.7563 12.2161 18.9584 11.8854 19.0632C11.4964 19.188 11.0904 19.2484 10.6828 19.242C10.3171 19.2437 9.9519 19.2131 9.59132 19.1506C9.28686 19.0996 8.98974 19.0102 8.70674 18.8844V17.6527C8.97726 17.8505 9.27948 17.9983 9.59976 18.0895C9.91896 18.1913 10.2508 18.2457 10.5851 18.251C10.8945 18.2711 11.2033 18.204 11.4781 18.057C11.6706 17.9458 11.7876 17.7351 11.7827 17.5089C11.784 17.3515 11.7232 17.2002 11.614 17.0894C11.4783 16.9529 11.3212 16.8408 11.1492 16.7577C10.9507 16.6561 10.6585 16.5222 10.2725 16.3559C9.96545 16.2295 9.67145 16.0721 9.39487 15.886Z"
					fill="white"
				/>
			</g>
		</svg>
	);
};
